import React from 'react'

import './Header.css'

const header = props => {
  let headerClasses = [''];
  let headerTitle = 'TITLE';
  let headerSubtitle = 'SUBTITLE';
  let headerImage = null;
  if (props.headerProps) {
    headerClasses = props.headerProps.classes;
    headerTitle = props.headerProps.title;
    headerSubtitle = props.headerProps.subtitle;
    headerImage = props.headerProps.image;
  }
  //console.log(headerImage);

  let subTitle = headerSubtitle !== "" ? <p>{headerSubtitle}</p> : ""

  return (
    <header className={headerClasses.join(' ')}>
      <h2>{headerTitle}</h2>
      {subTitle}
      {
       headerImage != null ? <img className="header_image" src={headerImage} alt="Header"></img>:
       null
      }
    </header>
  )
}

export default header
